// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"702e2f11","605":"9279124c","809":"62452d41","981":"530d0564"}[chunkId] + ".chunk.js";
};